import { View, StyleSheet, Image, TouchableWithoutFeedback } from 'react-native'
import { useAuthContext } from '../../contexts/auth-context'
import { useNavigation } from '@react-navigation/native'
import { AppNavigation } from '../../navigation/types'
import { useCallback, useEffect } from 'react'
import { Text, TouchableRipple } from 'react-native-paper'
import {
  CorankIcon,
  CorankDisabled,
  CorankLock,
  PNGCoRankBkg,
} from '../../utils/meldd-icons'
import { SocketEvents, useSocketRoom } from '../../socket/socket.hooks'
import colors from '../../constants/colors'
import { useNode } from '../../contexts/current-node.provider'

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: 40,
    height: 40,
    borderRadius: 20,
    overflow: 'hidden',
  },
  containerWithBorder: {
    position: 'relative',
    width: 32,
    height: 32,
    borderRadius: 16,
    overflow: 'hidden',
    borderWidth: 0.5,
    borderColor: colors.primaryAccent,
  },
  contentWrapper: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {},
  tagContainer: {
    position: 'absolute',
    bottom: -10,
    left: 0,
    right: 0,
    padding: 0,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 1,
  },
})
/**
 * DOC: https://www.notion.so/coderbunker/corankButton-corankTag-2960892b6c3080eca585dffef775034b?source=copy_link
 */

export function MyCoRank() {
  const navigation = useNavigation<AppNavigation>()
  const { userCorank, refreshCorank, currentNode } = useNode()
  const { userId } = useAuthContext()

  const socketRefreshCorank = useCallback(() => {
    // Corank updates happens on a transaction, when we receive the event the transaction may not yet saved
    !!currentNode && setTimeout(() => refreshCorank(currentNode?.id || ''), 300)
  }, [currentNode, refreshCorank])

  useSocketRoom(userId).event(SocketEvents.Refresh, socketRefreshCorank)

  // When comming from a page without corank, try to reload
  useEffect(() => {
    socketRefreshCorank()
  }, [userCorank])

  return (
    <TouchableRipple onPress={() => navigation.navigate('Profile', { userId })}>
      <CoRankLabel corank={userCorank} showBorder />
    </TouchableRipple>
  )
}

export function CorankTag({
  corank,
  size = 22,
}: {
  corank: number | null | undefined
  size?: number
}) {
  if (corank === null || corank === undefined) {
    return null
  }

  const IconComponent = corank > 0 ? CorankIcon : CorankDisabled

  return (
    <View style={{ position: 'relative', alignItems: 'center' }}>
      {/* Lock icon positioned at the top */}
      <View style={{ position: 'absolute', top: -1.5, left: -1, zIndex: 1 }}>
        <CorankLock size={8} />
      </View>

      {/* Main content - bars only */}
      <View style={{ alignItems: 'center' }}>
        <IconComponent size={size} />
      </View>

      {/* White space at the bottom with text */}
      <View style={styles.tagContainer}>
        <Text style={{ fontSize: 11, fontWeight: '500' }}>{corank}</Text>
      </View>
    </View>
  )
}

export function CoRankLabel({
  corank,
  showBorder,
  size = 40,
}: {
  corank?: number | null
  showBorder?: boolean
  size?: number
}) {
  if (corank === null || corank === undefined) {
    return
  }
  return (
    <View style={showBorder ? styles.containerWithBorder : styles.container}>
      <View style={styles.contentWrapper}>
        <Image source={PNGCoRankBkg} style={[{ width: size, height: size }]} />
      </View>
      <View style={styles.contentWrapper}>
        <Text variant={'labelLarge'}>{corank}</Text>
      </View>
    </View>
  )
}
